module.exports = __webpack_public_path__ + "static/media/planet-red.10bbc074.png";